// src/router/index.js
import Vue from 'vue'
import Router from 'vue-router'
import { getI18n } from '@/i18n'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/index.vue'),
      meta: { titleKey: 'home.title' }
    },
    {
      path: '/map',
      name: 'map',
      component: () => import('@/views/map.vue'),
      meta: { titleKey: 'map.title' }
    },
    {
      path: '/predict',
      name: 'predict',
      component: () => import('@/views/predict.vue'),
      meta: { titleKey: 'earthquake.title' }
    },
    {
      path: '/plate',
      name: 'plate',
      component: () => import('@/views/plate.vue'),
      meta: { titleKey: 'plate.title' }
    }
  ]
})

// 页面 title 国际化：appName - 页面标题
function updateTitle(to) {
  const i18n = getI18n()
  // i18n 尚未创建（极端情况，如启动早期）时用兜底
  const t = (key) => (i18n ? i18n.t(key) : key)

  const appName = t('common.appName')
  const key = to && to.meta && to.meta.titleKey
  const pageTitle = key ? t(key) : ''

  // 避免把未翻译的 key 直接显示出来
  const safePageTitle =
    pageTitle && pageTitle !== key ? pageTitle : ''

  document.title = safePageTitle ? `${appName} - ${safePageTitle}` : appName
}

router.afterEach((to) => {
  updateTitle(to)
})

// 语言切换后刷新 title（内页不 reload 时也能更新）
window.addEventListener('lang-changed', () => {
  updateTitle(router.currentRoute)
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js